import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './NewHighsAndLows.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function NewHighsAndLows(props) {
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let optionInfoMarket = "New High & Low";
    let optionTypeComp = "Daily Market Tracker";
    const [data, setData] = useState([]);
    const [valuebtn, setValueBtn] = useState("high");
    // const [valueLi, setValueLi] = useState("m1");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    const [valueLy, setValueLy] = useState("year");
    const [groupIndex, setGroupIndex] = useState("bse_sensex");
    const [groupIndexNSE, setGroupIndexNSE] = useState("nifty");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);

        if (groupValue === "BSE") {
            if (valuebtn === "high") {
                if (valueLy === "year") {
                    const getUrl = BaseURL + "AllHighLow";
                    fetch(`${getUrl}/${groupValue}/52NH/${groupIndex}/-/100`)
                        .then((response) => response.json())
                        .then((data) => {
                            getData = data.data;
                            setData(getData);
                            //console.log(getData, "getData")
                            setloadingshow(false);


                        })
                        .catch((error) => {
                        });
                } else {
                    const getUrl = BaseURL + "AllHighLow";
                    fetch(`${getUrl}/${groupValue}/ALLNH/${groupIndex}/-/100`)
                        .then((response) => response.json())
                        .then((data) => {
                            getData = data.data;
                            setData(getData);
                            setloadingshow(false);


                            //console.log(getData, "getData")
                        })
                        .catch((error) => {
                        });
                }
            } else {
                if (valueLy === "year") {
                    const getUrl = BaseURL + "AllHighLow";
                    fetch(`${getUrl}/${groupValue}/52NL/${groupIndex}/-/100`)
                        .then((response) => response.json())
                        .then((data) => {
                            getData = data.data;
                            setData(getData);
                            // console.log(getData, "getData")
                            setloadingshow(false);


                        })
                        .catch((error) => {
                        });
                } else {
                    const getUrl = BaseURL + "AllHighLow";
                    fetch(`${getUrl}/${groupValue}/ALLNL/${groupIndex}/-/100`)
                        .then((response) => response.json())
                        .then((data) => {
                            getData = data.data;
                            setData(getData);
                            // console.log(getData, "getData")
                            setloadingshow(false);


                        })
                        .catch((error) => {
                        });
                }

            }
        }
        else {
            if (valuebtn === "high") {
                if (valueLy === "year") {
                    const getUrl = BaseURL + "AllHighLow";
                    fetch(`${getUrl}/${groupValue}/52NH/${groupIndexNSE}/-/100`)
                        .then((response) => response.json())
                        .then((data) => {
                            getData = data.data;
                            setData(getData);
                            // console.log(getData, "getData")
                            setloadingshow(false);


                        })
                        .catch((error) => {
                        });
                } else {
                    const getUrl = BaseURL + "AllHighLow";
                    fetch(`${getUrl}/${groupValue}/ALLNH/${groupIndexNSE}/-/100`)
                        .then((response) => response.json())
                        .then((data) => {
                            getData = data.data;
                            setData(getData);
                            // console.log(getData, "getData")
                            setloadingshow(false);


                        })
                        .catch((error) => {
                        });
                }
            } else {
                if (valueLy === "year") {
                    const getUrl = BaseURL + "AllHighLow";
                    fetch(`${getUrl}/${groupValue}/52NL/${groupIndexNSE}/-/100`)
                        .then((response) => response.json())
                        .then((data) => {
                            getData = data.data;
                            setData(getData);
                            setloadingshow(false);


                            // console.log(getData, "getData")
                        })
                        .catch((error) => {
                        });
                } else {
                    const getUrl = BaseURL + "AllHighLow";
                    fetch(`${getUrl}/${groupValue}/ALLNL/${groupIndexNSE}/-/100`)
                        .then((response) => response.json())
                        .then((data) => {
                            getData = data.data;
                            setData(getData);
                            setloadingshow(false);
                            //console.log(getData, "getData")
                        })
                        .catch((error) => {
                        });
                }

            }
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, valuebtn, valueLy, groupIndex, groupIndexNSE]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("New High Low",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>New High &amp; Low</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='newhigh-loser-sc'>
                            <div className='newhigh-header'>
                                <h2><span>New High And Low</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='newhigh-table-main'>
                                <div className="newhighselect">
                                    <div className='newhigh-loser-toggle'>
                                        <button id="btnGain" value="high" className={(valuebtn === "high") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Highs</button>
                                        <button id="btnLoose" value="lows" className={(valuebtn === "lows") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Lows</button>
                                    </div>

                                    <div className='newhigh-inner-select'>

                                        <select onChange={(event) => { setValueLy(event.target.value); }}>
                                            <option value="year" selected>Year</option>
                                            <option value="life" >Life</option>

                                        </select>
                                    </div>

                                    <div className='newhigh-inner-select_I'>
                                        <select onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>
                                    <div className='newhigh-inner-selectIndex'>
                                        {(groupValue === "BSE") ?
                                            <select onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                )
                                                )}
                                            </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                )
                                                )}
                                            </select>}
                                    </div>
                                </div>
                                {/* <hr className="hrNewHighsLows"></hr> */}
                                <div className='newhigh-table table-responsive'>
                                    <table className='table'>
                                        {(() => {
                                            if (groupValue === "BSE") {
                                                if (valuebtn === "high") {
                                                    return (
                                                        <><thead>
                                                            <tr>
                                                                <th className='text-left'>Company Name</th>
                                                                <th className='text-right'>LTP(&#8377;)</th>
                                                                <th className='text-right' >Today's High(&#8377;)</th>
                                                                <th className='text-right'>Yearly High(&#8377;)</th>
                                                                <th className='text-right'>Yearly High Date</th>

                                                            </tr>
                                                        </thead>
                                                            <tbody>
                                                                {currentTableData && currentTableData.map(
                                                                    ({ lname, BTPRICE, B52HIGH, Cprice, B52HDATE, BTHIGH, CO_CODE }) => (
                                                                        <tr>
                                                                            <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + CO_CODE}>{lname}</h6></td>
                                                                            <td className="text-right"> {(BTPRICE != null) ? BTPRICE.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(BTHIGH != null) ? BTHIGH.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(B52HIGH != null) ? B52HIGH.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(B52HDATE != null) ? B52HDATE.split("T")[0] : 0}</td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody></>
                                                    )
                                                } else {
                                                    return (
                                                        <><thead>
                                                            <tr>
                                                                <th className='text-left'>Company Name</th>
                                                                <th className='text-right'>LTP(&#8377;)</th>
                                                                <th className='text-right' >Today's Low(&#8377;)</th>
                                                                <th className='text-right'>Yearly Low(&#8377;)</th>
                                                                <th className='text-right'>Yearly Low Date</th>

                                                            </tr>
                                                        </thead>
                                                            <tbody>
                                                                {currentTableData && currentTableData.map(
                                                                    ({ lname, BTPRICE, B52LOW, Cprice, B52LDATE, BTLOW, CO_CODE }) => (
                                                                        <tr>
                                                                            <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + CO_CODE}>{lname}</h6></td>
                                                                            <td className="text-right"> {(BTPRICE != null) ? BTPRICE.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(BTLOW != null) ? BTLOW.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(B52LOW != null) ? B52LOW.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(B52LDATE != null) ? B52LDATE.split("T")[0] : 0}</td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody></>)
                                                }
                                            } else {
                                                if (valuebtn === "high") {
                                                    return (
                                                        <><thead>
                                                            <tr>
                                                                <th className='text-left'>Company Name</th>
                                                                <th className='text-right'>LTP(&#8377;)</th>
                                                                <th className='text-right' >Today's High(&#8377;)</th>
                                                                <th className='text-right'>Yearly High(&#8377;)</th>
                                                                <th className='text-right'>Yearly High Date</th>

                                                            </tr>
                                                        </thead>
                                                            <tbody>
                                                                {currentTableData && currentTableData.map(
                                                                    ({ lname, NTPRICE, N52HIGH, Cprice, N52HDATE, NTHIGH, CO_CODE }) => (
                                                                        <tr>
                                                                            <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + CO_CODE}>{lname}</h6></td>
                                                                            <td className="text-right"> {(NTPRICE != null) ? NTPRICE.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(NTHIGH != null) ? NTHIGH.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(N52HIGH != null) ? N52HIGH.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(N52HDATE != null) ? N52HDATE.split("T")[0] : 0}</td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody></>
                                                    )
                                                } else {
                                                    return (
                                                        <><thead>
                                                            <tr>
                                                                <th className='text-left'>Company Name</th>
                                                                <th className='text-right'>LTP(&#8377;)</th>
                                                                <th className='text-right' >Today's Low(&#8377;)</th>
                                                                <th className='text-right'>Yearly Low(&#8377;)</th>
                                                                <th className='text-right'>Yearly Low Date</th>

                                                            </tr>
                                                        </thead>
                                                            <tbody>
                                                                {currentTableData && currentTableData.map(
                                                                    ({ lname, NTPRICE, N52LOW, Cprice, N52LDATE, NTLOW, CO_CODE }) => (
                                                                        <tr>
                                                                            <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + CO_CODE}>{lname}</h6></td>
                                                                            <td className="text-right"> {(NTPRICE != null) ? NTPRICE.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(NTLOW != null) ? NTLOW.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(N52LOW != null) ? N52LOW.toFixed(2) : 0}</td>
                                                                            <td className="text-right"> {(N52LDATE != null) ? N52LDATE.split("T")[0] : 0}</td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody></>)
                                                }
                                            }
                                        })()}
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default NewHighsAndLows;